import React, { Component } from "react";
import { Translation, withTranslation } from "react-i18next";
import { withRouter } from "react-router";
import { toast } from "react-toastify";
import { MailPersonListQuery } from "../../constants/apiParams";
import apiCall, { METHOD } from "../../constants/baseUrl";
import { getUserID } from "../../util/utils";
import LoadingPage from "../CommanComponents/LoadingPage";

class SearchPerson extends Component {
  constructor(props) {
    super(props);

    this.state = {
      search: "",
      personList: [],
      groupList:[],
      isLoading: false
    };
    this.searchRef = React.createRef();
  }
  changeEventSearch = e => {
    const searchValue = e.target.value;
    this.setState(
      {
        search: searchValue,
        personList: [],
        groupList:[]
      },
      () => {
        this.props.searchArray(
          { person_list: [], group_list: [] },
          this.state.search
        );
      }
    );
  };

  handleLoader = status => {
    this.setState(() => {
      return {
        isLoading: status
      };
    });
  };

  handleSearchResponse = data => {
    this.setState(
      () => {
        return {
          personList: data.person_list,
          groupList: data.group_list,
          isLoading: false
        };
      },
      () => {
        this.props.searchArray(
          { person_list: data.person_list, group_list: data.group_list },
          this.state.search
        );
        if (
          this.state.personList.length == 0 &&
          this.state.groupList.length == 0
        ) {
          toast.info(
            this.props.t("GeneralMessages.searchErrorMessage") +
              "'" +
              this.state.search +
              "'"
          );
        }
      }
    );
  };
  loader = (<LoadingPage />);
  clearSearch = () => {
    this.searchRef.current.value = "";

    this.setState(
      () => {
        return {
          ...this.state,
          search: "",
          personList: [],
          groupList: []
        };
      },
      () => {
        this.props.searchArray({ person_list: [], group_list: [] },this.state.search);
      }
    );
  };

  searchApi = () => {
    const { search } = this.state;
    const mail_list_id = this.props.match.params.mail_person_id;
    const fields = mail_list_id.split("-");
    const list_id = fields[0];
    apiCall(
      METHOD.QUERY,
      MailPersonListQuery(getUserID(), list_id, search),
      (data) => this.handleSearchResponse(data),
      (isLoading) => this.handleLoader(isLoading),
      (data) => {
        toast.error(this.props.t(data.message));
      }
    );
  };

  render() {
    const { search } = this.state;
    return (
      <Translation ns="translation">
        {(t, { i18n }) => {
          return (
            <div className="clearfix mt-4">
              <div className="input-group mt-3">
                <input
                  type="text"
                  placeholder={t("personList.searchPlaceHolder")}
                  className="form-control"
                  ref={this.searchRef}
                  onChange={this.changeEventSearch}
                  onKeyPress={e =>
                    e.keyCode == 13 || (e.which == 13 && this.searchApi())
                  }
                />
                <div className="input-group-append ">
                  <span className="input-group-text bg-white input-group-append ">
                    <i
                      className="zmdi zmdi-search zmdi-hc-fw font-22 pointer"
                      onClick={this.searchApi}
                    ></i>
                    {search.length != 0 && (
                      <i
                        className="zmdi zmdi-close zmdi-hc-fw font-22 pointer"
                        onClick={this.clearSearch}
                      ></i>
                    )}
                  </span>
                </div>
              </div>
            </div>
          );
        }}
      </Translation>
    );
  }
}
export default withTranslation()(withRouter(SearchPerson));